import type { DOMPurify } from 'dompurify'

type StripAnchorTags = (html: string | undefined | null) => string
type Purifier = Pick<DOMPurify, 'sanitize'>

export function createStripAnchorTags(purify: Purifier): StripAnchorTags {
  return (html: string | undefined | null) => {
    if (!html) {
      return ''
    }

    return purify.sanitize(html, {
      ALLOWED_TAGS: ['span'],
      ALLOWED_ATTR: ['class'],
      RETURN_DOM: false,
    })
  }
}
